import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import ConnectedAccountInputs from '../components/AccountInputsV1';
import Layout from '../components/Layout';
import withPackages from '../containers/withPackages';
import ConnectedAccountInputsV2 from '../components/AccountInputsV2/Connector';

export class Account extends React.Component {
  componentDidMount() {
    this.props.getPackages();
  }

  render() {
    const query = queryString.parse(this.props.location.search);
    if (query.aws) {
      return (
        <Layout
          title="Let’s Get Started"
          subtitle="Review your plan and create an account."
        >
          <ConnectedAccountInputs />
        </Layout>
      );
    }
    return (
      <Layout
        title="Let’s Get Started"
        subtitle="Review your plan and create an account."
      >
        <ConnectedAccountInputsV2 />
      </Layout>
    );
  }
}

Account.propTypes = {
  getPackages: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withPackages(Account);
